import { KeyboardShortcutName } from '../../../cross-team-shared/misc-services/keyboard-shortcut.service';
import { outputShortcuts2d } from '../annotation-shared/output-shortcuts-2d';

export const videoOutputshortcuts: KeyboardShortcutName[] = [
  ...outputShortcuts2d,
  'changeShapeVisibility',
];
